import { gql } from "@apollo/client";

export const MARK_MONITOR_EVENT_AS_HANDLED = gql`
  mutation markTheMonitorEventAsHandled(
    $input: MarkMonitoringEventAsHandledInput!
  ) {
    aml {
      markMonitorEventAsHandled(input: $input) {
        success
      }
    }
  }
`;
